// Top bar — breadcrumb + search + notifications + chat pill + cart.
// Per spec §10.2.

import { Search, Bell, MessageCircle, ShoppingBag } from 'lucide-react';

interface TopBarProps {
  viewLabel: string;
}

export function TopBar({ viewLabel }: TopBarProps) {
  return (
    <header className="topbar">
      <div className="topbar__crumbs">
        <span>Studio</span>
        <span aria-hidden="true">›</span>
        <span className="topbar__crumb-current">{viewLabel}</span>
      </div>
      <div className="topbar__actions">
        <button type="button" className="topbar__btn" aria-label="Search">
          <Search size={20} aria-hidden="true" strokeWidth={1.6} />
        </button>
        <button type="button" className="topbar__btn" aria-label="Notifications">
          <Bell size={20} aria-hidden="true" strokeWidth={1.6} />
        </button>
        <button
          type="button"
          className="topbar__help-pill"
          onClick={() => {
            // Open Intercom/HelpScout if present, otherwise mailto.
            const w = window as unknown as { Beacon?: (cmd: string) => void };
            if (typeof w.Beacon === 'function') {
              w.Beacon('open');
              return;
            }
            window.location.href = 'mailto:hello@marketdwellings.com';
          }}
        >
          <MessageCircle size={18} aria-hidden="true" strokeWidth={1.6} />
          <span>Need help? Chat with us</span>
        </button>
        <a className="topbar__btn" href="/cart" aria-label="Cart">
          <ShoppingBag size={20} aria-hidden="true" strokeWidth={1.6} />
        </a>
      </div>
    </header>
  );
}
